import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import {
  VENTASREPORTES_MAIN,
  VENTASRAPIDAS_NUEVO,
  VENTASRAPIDAS_LISTA,
  VENTAS_NUEVA,
  VENTAS_LISTA,
  VENTAS_SINENTREGA_NUEVA,
  VENTAS_SINENTREGA_LISTA
} from 'constants/codigosTransacciones'

import ListaPage from './lista'
import NuevaPage from './nueva'
import ReportesPage from './reporte'

export default function VentasPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${VENTASREPORTES_MAIN}`} component={ReportesPage} />
        <Route path={`/${VENTASRAPIDAS_NUEVO}/:id`} component={NuevaPage} />
        <Route path={`/${VENTASRAPIDAS_NUEVO}`} component={NuevaPage} />
        <Route path={`/${VENTASRAPIDAS_LISTA}`} component={ListaPage} />
        <Route path={`/${VENTAS_NUEVA}/:id/:tipoDocumento/:version`} component={NuevaPage} />
        <Route path={`/${VENTAS_NUEVA}/:id/:tipoDocumento`} component={NuevaPage} />
        <Route path={`/${VENTAS_NUEVA}/:id`} component={NuevaPage} />
        <Route path={`/${VENTAS_NUEVA}`} component={NuevaPage} />
        <Route path={`/${VENTAS_LISTA}`} component={ListaPage} />
        <Route path={`/${VENTAS_SINENTREGA_NUEVA}/:id/:tipoDocumento`} component={NuevaPage} />
        <Route path={`/${VENTAS_SINENTREGA_NUEVA}/:id`} component={NuevaPage} />
        <Route path={`/${VENTAS_SINENTREGA_NUEVA}`} component={NuevaPage} />
        <Route path={`/${VENTAS_SINENTREGA_LISTA}`} component={ListaPage} />
      </Switch>
    </Suspense>
  )
}
